// @ts-nocheck
import React, { createContext, ReactNode } from "react";
import useSearchIndex from "../hooks/useSearchIndex";

export const SearchContext = createContext({
  searchAction: (text: string) => [],
});

interface Props {
  data: any;
  children: ReactNode;
}

function SearchContextProvider({ children, data }: Props) {
  const { searchAction } = useSearchIndex(data);

  return (
    <SearchContext.Provider value={{ searchAction }}>
      {children}
    </SearchContext.Provider>
  );
}

export default SearchContextProvider;
